/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import BackgroundElement from '../components/BackgroundElement';
import BannerCategory from '../components/BannerCategory';
import BannerImage from '../components/BannerImage';
import BannerLinkButton from '../components/BannerLinkButton';
import BannerOverline from '../components/BannerOverline';
import BannerSubtitle from '../components/BannerSubtitle';
import BannerTeaser from '../components/BannerTeaser';
import BannerTitle from '../components/BannerTitle';
import Disruptor from '../components/Disruptor';
import LinkWrapper from '../components/LinkWrapper';
import AbstractLayout from './AbstractLayout';

export default class NewReadingMaterial extends AbstractLayout {
	get key() {
		return 'new_reading_material';
	}

	content() {
		const { banner } = this.attrs;

		return (
			<LinkWrapper banner={banner}>
				<div className="Banner-content">
					<BackgroundElement banner={banner} />

					<div className="BannerContentContainer NewReadingMaterial-visual">
						<BannerImage banner={banner} />
						<Disruptor banner={banner} />
					</div>

					<div className="BannerContentContainer NewReadingMaterial-text">
						<div className="BannerContentContainer">
							<BannerTitle banner={banner} />
							<BannerSubtitle banner={banner} />
							<BannerOverline banner={banner} />
							<BannerCategory banner={banner} />
						</div>

						<div className="BannerContentContainer">
							<BannerTeaser banner={banner} />
							<BannerLinkButton banner={banner} />
						</div>
					</div>

					<div className="BannerContentContainer NewReadingMaterial-text--mobile">
						<div className="BannerContentContainer">
							<BannerTitle banner={banner} />
							<BannerTeaser banner={banner} />
							<BannerCategory banner={banner} />

							<BannerLinkButton banner={banner} />
						</div>

						<div className="BannerContentContainer">
							<BannerSubtitle banner={banner} />
							<BannerOverline banner={banner} />
							<Disruptor banner={banner} />
						</div>
					</div>
				</div>
			</LinkWrapper>
		);
	}
}
